/** @format */

import { request } from 'src/utils'

const API = {
  getTemplateList: '/monitor/?Action=DescribeConditionsTemplates&Version=2024-01-01',
  createTemplate: '/monitor/?Action=CreateConditionsTemplate&Version=2024-01-01',
  modifyTemplate: '/monitor/?Action=ModifyConditionsTemplate&Version=2024-01-01',
  copyTemplate: '/monitor/?Action=CopyConditionsTemplate&Version=2024-01-01',
  deleteTemplate: '/monitor/?Action=DeleteConditionsTemplate&Version=2024-01-01'
}

// 获取模版信息
export const getTemplate = async id => {
  const result = await request(API.getTemplateList, {
    data: { TemplateID: id, ProductType: 999 }
  })
  if (result?.code === 'Success') {
    return result?.data?.Templates?.[0] || {}
  }
}
// 获取模版列表
export const getTemplateList = async params => {
  const result = await request(API.getTemplateList, {
    data: { ...params }
  })
  if (result?.code === 'Success') {
    return result?.data?.Templates || {}
  }
}

// 编辑模版
export const modifyTemplate = async (params: any) => {
  const result = await request(API.modifyTemplate, {
    method: 'POST',
    data: { ...params }
  })
  if (result?.code === 'Success') {
    return true
  }
}
// 创建模版
export const createTemplate = async (params: any) => {
  const result = await request(API.createTemplate, {
    method: 'POST',
    data: { ...params }
  })
  if (result?.code === 'Success') {
    return true
  }
}

// 复制模版
export const copyTemplate = async id => {
  const result = await request(API.copyTemplate, {
    method: 'POST',
    data: { TemplateID: id }
  })
  if (result?.code === 'Success') {
    return true
  }
}

// 删除模版
export const deleteTemplate = async id => {
  const result = await request(API.deleteTemplate, {
    method: 'POST',
    data: { TemplateID: id }
  })
  if (result?.code === 'Success') {
    return true
  }
}

export default API
